// PageNavMenuItemCheckBox
// ***********************************************************************************************************************
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import * as React from "react";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";

export interface IPageNavMenuItemCheckBoxProp {
    classes?: string;
    hidden?: boolean;
    isActive: boolean;
    items: IIdTitle[];
    activeItemIds: string[];
    title: string;
    onToggleMenuItem: () => void;
    onSetActiveItem: (itemId: string, value: boolean) => void;
}

export class PageNavMenuItemCheckBox extends React.Component<IPageNavMenuItemCheckBoxProp, {}> {
    render() {
        const props = this.props;
        if (props.hidden) return null;
        const items = props.items;
        return (
            <>
                <Accordion expanded={props.isActive}>
                    <AccordionSummary onClick={props.onToggleMenuItem} expandIcon={<ExpandMoreIcon />}>
                        {props.title}
                    </AccordionSummary>
                    <AccordionDetails>
                        {items &&
                        <Stack>
                            {items.map((item) => {
                                const isActiveItem = props.activeItemIds.indexOf(item.id) > -1;
                                if (props.isActive) {
                                    return <FormControlLabel
                                        key={item.id}
                                        label={item.title}
                                        control={
                                            <Checkbox checked={isActiveItem} />
                                        }
                                        onClick={(e) => { e.stopPropagation(); e.preventDefault(); props.onSetActiveItem(item.id, !isActiveItem); }}
                                    />;
                                } else {
                                    return <div key={item.id} className={"menuItem" + (isActiveItem ? " leftPad active" : "")} onClick={() => props.onSetActiveItem(item.id, false) }>
                                        {item.title}
                                    </div>;
                                }
                            })}
                        </Stack>
                        }
                    </AccordionDetails>
                </Accordion>
                {!props.isActive && (
                    <Stack sx={{ margin: ".5rem" }}>
                        {items.filter(x => props.activeItemIds.includes(x.id)).map((item) => (
                            <Typography key={item.id}>{item.title}</Typography>
                        ))}
                    </Stack>
                )}
            </>
        );
    }
}